import { useContext } from 'react';

import { QSetSimilarityCheckResultDetailsContext } from './qset-similarity-check-result-details-provider';

export default function useQSetSimilarityCheckResultDetails() {
  const context = useContext(QSetSimilarityCheckResultDetailsContext);
  if (!context) {
    throw new Error(
      'useQSetSimilarityCheckResultDetails must be used within a QSetSimilarityCheckResultDetailsProvider',
    );
  }
  return context;
}
